<template>
  <div>
    <span
      @dragenter.prevent="handleDragEnter"
      @dragover.prevent="handleDragOver"
      @drop.prevent="handleDrop"
      @dragleave.prevent="handleLeave"
      class="container"
    ></span>
    <div class="aviso-upload">
      <div class="row col-12 q-mb-md" id="card-aviso-container">
        <q-card style="background: #6391f4" class="card q-pa-md">
          <span class="row col-12 justify-center text-white">
            <q-icon name="file_upload" size="sm" />
          </span>
          <span class="text-white">Solte o arquivo para fazer upload</span>
        </q-card>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineEmits } from "vue";

const emit = defineEmits(["enviarArquivo"]);

const handleDragEnter = () => {
  const card = document.getElementById("card-aviso-container");
  card.style.display = "block";
};

const handleDragOver = (event) => {
  event.dataTransfer.dropEffect = "copy";
};

const handleLeave = () => {
  const card = document.getElementById("card-aviso-container");
  card.style.display = "none";
};

const handleDrop = (event) => {
  event.preventDefault();
  const files = event.dataTransfer.files;
  emit("enviarArquivo", files);
  const card = document.getElementById("card-aviso-container");
  card.style.display = "none";
};
</script>

<style scoped>
.container {
  background-color: transparent;
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
}
.container {
  background-color: transparent;
}
.aviso-upload {
  width: 100%;
  display: flex;
  justify-content: center;
}
#card-aviso-container {
  display: none;
  position: fixed;
  bottom: 0;
  z-index: 3;
}
.container-modal-excluir {
  width: 100%;
  height: 250px;
  padding: 10px 10px 0px 10px;
  margin: 0px;
  border-radius: 10px;
}
</style>
